<script setup lang="ts">
const nonbreakEl = ref<HTMLElement | null>(null)
const nonbreakElBounds = useElementBounding(nonbreakEl, {})
const breakEl = ref<HTMLElement | null>(null)
const breakElBounds = useElementBounding(breakEl, {})

const parentEl = useParentElement(nonbreakEl)
const parentBounds = useElementBounding(parentEl, { windowResize: true })

const isBreaking = computed(() => {
  return nonbreakElBounds.height.value < breakElBounds.height.value
})
</script>

<template>
  <div ref="nonbreakEl" class="test-nonbreaking">
    <slot :breaking="false" />
  </div>
  <div ref="breakEl" class="test-breaking" :style="`width: ${parentBounds?.width.value ?? 0}px`">
    <slot :breaking="false" />
  </div>
  <slot :breaking="isBreaking" />
</template>

<style scoped>
.test-breaking, .test-nonbreaking {
  position: fixed;
  left: 0;
  top: -99999px;
  visibility: hidden;
  user-select: none;
  pointer-events: none;
}

.test-nonbreaking {
    width: 999999px;
}
</style>
